import { render } from "./InfoPage.vue?vue&type=template&id=08ebb805&ts=true"
import script from "./InfoPage.vue?vue&type=script&lang=ts"
export * from "./InfoPage.vue?vue&type=script&lang=ts"

import "./InfoPage.vue?vue&type=style&index=0&id=08ebb805&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/Dashboard/Dashboard_CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__